import { getPostLoginDestination } from "./postLoginDestination";

export type AuthSuccessFlow = "login" | "register";

/**
 * Registration is the only entry point into onboarding. Ordinary logins keep
 * the deployment-aware destination so returning users are never interrupted.
 */
export function getAuthenticatedDestination(flow: AuthSuccessFlow): string {
  return flow === "register" ? "/onboarding" : getPostLoginDestination();
}
